<template>
  <!-- Page Content -->
  <div class="row f-row justify-content-center h-100">
    <div class="f-row h-100">
      <div
        class="left-sidebar-front-div"
        v-if="userSelections.visibleLeft"
        @click="changeVisible"
      ></div>
      <!-- Sidebar lateral -->
      <LeftSidebar
        :selectedAnalysis="userSelections['selectedAnalysis']"
        :selectedAnalysisParent="userSelections['selectedAnalysisParent']"
        :visibleLeft="userSelections.visibleLeft"
        :selectedSheet="newSelectedSheet"
        @eventOnLeftSidebarAnalysis="onLeftSidebarAnalysis"
        @eventOnUserClickLeftSidebarShow="onUserClickLeftSidebarShow"
        @eventOnClientSelect="onClientSelectSheet"
      />
      <div class="h-100 d-flex flex-column largeBox row f-row">
        <div class="row f-row justify-content-center h-100 col-12">
          <div
            class="col col-12 text-center progress-div"
            v-if="showCompanyPortfolioLoading"
            style="top: 45%;"
          >
            <QSLoading
              :isLoading="showCompanyPortfolioLoading"
              :size="45"
              :colorTheme="colorTheme"
            />
          </div>
          <div :class="getStyleConteiner()" v-else>
            <!-- No Companies created, new user -->
            <div class="row f-row mt-2 home-new-user" v-if="companyLen === 0">
              <div class="col col-12 text-center mt-2">
                Please name Your Company, one portfolio and select at least one
                currency (you will be able to create other portfolios
                afterwards).
              </div>
              <!--TODO: meter commodities-->
              <CreateCompanyComponent
                @eventOnAfterSaveCompany="onAfterSaveCompany"
                @eventOnBeforeSaveCompany="onBeforeSaveCompany"
              />
            </div>
            <!-- Company/Portfolio/Asset Selection -->
            <div class="row f-row mt-2 justify-content-start" v-else>
              <div
                class="txt-label-primary-2"
                style="width: 180px; justify-content: flex-start!important;"
                v-show="selectedSheet !== 3"
              >
                <span style="padding-left: 10px!important;"
                  >Create / Update:</span
                >&nbsp;
                <button
                  v-on:click="editCompanyPortfolios"
                  type="submit"
                  class="btn btn-up-dn-load"
                >
                  <i class="fa fa-edit" aria-hidden="true"></i>
                </button>
              </div>
              <div
                class="txt-label-primary-2"
                style="width: 80px; justify-content: flex-start!important;"
              >
                Company:
              </div>
              <div class="col col-2 ml-2 mr-4">
                <Dropdown
                  v-model="selectedCompany"
                  :options="companies"
                  @change="onUserCompanySelection"
                  optionLabel="company_name"
                  optionValue="id"
                  placeholder="Select a Company"
                  scrollHeight="400px"
                  :filter="true"
                >
                  <template #value="slotProps">
                    {{ companies[slotProps.value].company_name }}
                  </template>
                  <template #option="slotProps">
                    <div class="country-item">
                      <div>{{ slotProps.option.company_name }}</div>
                    </div>
                  </template>
                </Dropdown>
              </div>
              <div
                class="txt-label-primary-2"
                style="width: 80px; justify-content: flex-start!important;"
                v-show="selectedSheet !== 2 && selectedSheet !== 3"
              >
                Portfolios:
              </div>
              <div
                class="col col-2 ml-2 mr-4"
                v-show="selectedSheet !== 2 && selectedSheet !== 3"
              >
                <MultiSelect
                  v-model="selectedPortfolios"
                  :options="portfolios"
                  :filter="true"
                  placeholder="Select Portfolios"
                  class="p-column-filter"
                  optionLabel="name"
                  scrollHeight="400px"
                  @hide="onUserPortfolioSelection"
                >
                  <template #option="slotProps">
                    <div class="p-multiselect-representative-option">
                      <span class="image-text">{{
                        slotProps.option.name
                      }}</span>
                    </div>
                  </template>
                </MultiSelect>
              </div>
              <div
                class="txt-label-primary-2"
                style="width: 80px; justify-content: flex-start!important;"
                v-if="selectedSheet !== 2 && selectedSheet !== 3"
              >
                Commodities:
              </div>
              <div
                class="col col-2 ml-2 mr-4"
                v-if="selectedSheet !== 2 && selectedSheet !== 3"
              >
                <MultiSelect
                  v-model="selectedCommodity"
                  :options="commodities"
                  :filter="true"
                  placeholder="Select Portfolios"
                  class="p-column-filter"
                  optionLabel="name"
                  scrollHeight="400px"
                  @hide="onUserCommoditySelection"
                >
                  <template #option="slotProps">
                    <div class="p-multiselect-representative-option">
                      <span class="image-text">{{
                        slotProps.option.name
                      }}</span>
                    </div>
                  </template>
                </MultiSelect>
              </div>
            </div>
          </div>
          <!-- Tab 0 Commodities selected / Expo -->
          <div style="width: 100%;" v-if="selectedSheet === 0">
            <DataTableExpoCommodities
              :colorTheme="colorTheme"
              :dataSaved="dataSavedExpoCommodities"
              :dataVar="expoCommodities"
              :headersToExport="
                headersComExpo1.concat(headersComExpo2).concat(headersComExpo3)
              "
              :list_file="list_file"
              :processData="processData"
              :refreshLegend="refreshLegendExpoCommodities"
              :saveLegend="saveLegendExpoCommodities"
              :selectedCompany="selectedCompany"
              :selectedList="selectedSheet"
              :selectedNAsset="selectedNavAsset"
              :selectedPortfolios="selectedPortfolios"
              :showLoading="showLoadingExpoCommodities"
              @eventOnClientCreate="onClientCreateExpoCommodities"
              @eventOnEditItem="editItemExpoCommodities"
              @eventOnDeleteItem="deleteItemExpoCommodities"
              @eventOnCopyItem="onCopyItem"
              @eventOnClientSaveToDB="onClientSaveToDB(3)"
              @eventOnClientDiscard="onClientDiscardExpoCommodities"
              @eventOnAfterDelete="onAfterDeleteExpoCommodities"
              @eventOnAfterDeleteCompany="onAfterDeleteCompany"
            />
          </div>
          <!-- Tab 1 Commodities selected / Hedge -->
          <div style="width: 100%;" v-else-if="selectedSheet === 1">
            <DataTableHedgeCommodities
              :dataSaved="dataSavedHedgeCommodities"
              :dataVar="hedgeCommodities"
              :headersToExport="
                headersComExpo1.concat(headersComExpo2).concat(headersComExpo3)
              "
              :list_file="list_file"
              :optionTypes="optionTypes"
              :processData="processData"
              :refreshLegend="refreshLegendHedgeCommodities"
              :saveLegend="saveLegendHedgeCommodities"
              :selectedCompany="selectedCompany"
              :selectedList="selectedSheet"
              :selectedNAsset="selectedNavAsset"
              :selectedPortfolios="selectedPortfolios"
              :showLoading="showLoadingComHedge"
              @eventOnClientCreate="onClientCreateHedgeCommodities"
              @eventOnEditItem="editItemHedgeCommodities"
              @eventOnCopyItem="onCopyItemHedge"
              @eventOnDeleteItem="deleteItemHedgeCommodities"
              @eventOnClientSaveToDB="onClientSaveToDB(4)"
              @eventOnClientDiscard="onClientDiscardHedgeCommodities"
              @eventOnAfterDelete="onAfterDeleteHedgeCommodities"
              @eventOnAfterDeleteCompany="onAfterDeleteCompany"
            />
          </div>
          <!-- Tab 2 selected / Program -->
          <div
            style="width: 100%;"
            class="row f-row h-100"
            v-else-if="selectedSheet === 2"
          >
            <div class="col col-12 h-100">
              <DataModelProgram
                :colorTheme="colorTheme"
                :portfolioList="portfolios"
                :processData="processData"
                :programType="'commodities'"
                :selectedAsset="selectedNavAsset"
                :selectedCompany="companies[selectedCompany]"
                :selectedPortfolios="selectedPortfolios"
                :watcherCompanySelected="watcherCompanySelected"
                @eventOnProgramSelectionChange="onDataProgramSelection"
              />
            </div>
          </div>
          <!-- Tab 4 upload file -->
          <div
            class="row f-row parent-uploadFile"
            v-else-if="selectedSheet === 3"
          >
            <UploadFile
              :colorTheme="colorTheme"
              :companyInformation="companyInformation"
              :isCurrency="'commodities'"
            />
          </div>
          <!-- New/edit Expo Modal Commodities -->
          <div class="modal-upload-expo" v-if="showModalEditExpoCommodities">
            <NewEditExpoCommodities
              :allCommodities="allCommodities"
              :colorTheme="colorTheme"
              :createEditTextExpoCommodities="createEditTextExpoCommodities"
              :editedItemExpoCommodities="editedItemExpoCommodities"
              :expoOptionsCommodities="expoOptionsCommodities"
              :incoterms="incoterms"
              :pricingMethods="pricingMethods"
              @eventCancelModalExpoCommodities="onUserCancel"
              @eventValidatedExpoCommodities="validateBeforeSubmitCommodities"
            />
          </div>
          <!-- New/edit Commodity Hedge Modal Commodities-->
          <div class="modal-upload-expo" v-if="showModalEditHedgeCommodities">
            <NewEditHedgeCommodities
              :allCommodities="allCommodities"
              :colorTheme="colorTheme"
              :createEditTextHedgeCommodities="createEditTextHedgeCommodities"
              :editedItemHedgeCommodities="editedItemHedgeCommodities"
              :optionTypes="optionTypes"
              :strategies="strategies"
              @eventCancelModalHedgeCommodities="onUserCancel"
              @eventOnValidateBeforeSubmit="
                validateBeforeSubmitHedgeCommodities
              "
            />
          </div>
          <!-- Loading Modal -->
          <Messages
            :modal_message="modal_processing_message"
            :colorTheme="colorTheme"
          />
          <Messages
            :modal_message="modal_process_finished_message"
            :colorTheme="colorTheme"
          />
          <div v-if="companyLen > 0">
            <CompanyPortfoliosEdit
              :modal_message="modal_edit_company"
              :companies="companies"
              :selectedCompany="selectedCompany"
              :user="user"
              :watcherForEditCompany="watcherForEditCompany"
              :colorTheme="colorTheme"
              @eventOnAfterSavePortfolioCompany="onAfterSavePortfolioCompany"
              @eventOnBeforeSavePortfolioCompany="onBeforeSavePortfolioCompany"
            />
          </div>
          <!-- Loading Modal -->
          <div class="modal-upload-expo" v-show="showModalLoading">
            <div class="inside-modal">
              <div class="row f-row text-center">
                <div class="col col-12 progress-div" style="top: 30%;">
                  <img
                    :src="logo"
                    @mouseover="logo = logo_blue"
                    @mouseout="logo = logo_white"
                    height="40"
                    alt=""
                    style="padding: 0"
                  /><br /><br />
                  <span>Loading Your information... please wait</span
                  ><br /><br /><br />
                  <QSLoading
                    :isLoading="showModalLoading"
                    :size="45"
                    :colorTheme="colorTheme"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CompanyPortfoliosEdit from "@/components/modals/CompanyPortfoliosEdit";
import CreateCompanyComponent from "@/components/CreateCompanyPortfolio.vue";
import DataModelProgram from "@/components/dataModel/DataModelProgram";
import DataTableExpoCommodities from "@/components/dataModel/DataTableExpoCommodities.vue";
import DataTableHedgeCommodities from "@/components/dataModel/DataTableHedgeCommodities";
import Dropdown from "primevue/dropdown";
import Messages from "@/components/modals/Messages.vue";
import MultiSelect from "primevue/multiselect";
import NewEditExpoCommodities from "@/components/dataModel/NewEditExpoCommodities";
import NewEditHedgeCommodities from "@/components/dataModel/NewEditHedgeCommodities";
import { getExpoDataCommodities } from "@/_core/data/api_calls/getExpoDataCommodities";
import { getExpoOptionsDataCommodities } from "@/_core/data/api_calls/getExpoOptionsDataCommodities";
import { getHedgeDataCommodities } from "@/_core/data/api_calls/getHedgeDataCommodities";
import { getIncoterms } from "@/_core/data/api_calls/getIncoterms";
import { getOptionTypesData } from "@/_core/data/api_calls/getOptionTypesData";
import { getCommodityStrategiesData } from "@/_core/data/api_calls/getCommodityStrategiesData";
import { getPricingMethods } from "@/_core/data/api_calls/getPricingMethods";
import { saveUserPreferences } from "@/_core/data/SaveToDB";
import {
  companyPortfolioAsset,
  getDefaultItemExpoCommodities,
  getDefaultItemHedgeCommodities,
  getFirstCompany,
  getHeadersComExpo1,
  getHeadersComExpo2,
  getHeadersComExpo3,
  getHeadersComHedge1,
  getHeadersComHedge2,
  getHeadersComHedge3,
  setManagementInfoCommodities,
} from "@/_core/data/DataModel";
import {
  onClientSaveToDBExpoCommodities,
  onClientSaveToDBHedgeCommodities,
} from "@/_core/data/SaveToDB";
import {
  contractMonthYearParse,
  timeParseNoNull,
} from "@/_core/_helpers/_helpers";
import LeftSidebar from "./sidebar/LeftSidebar.vue";
import UploadFile from "./uploadFile/UploadFile.vue";
import QSLoading from "@/components/QSLoading.vue";
import { dataModelRouteSync } from "./dataModelRouteSync";

export default {
  name: "Commodity",
  mixins: [dataModelRouteSync],
  components: {
    QSLoading,
    CompanyPortfoliosEdit,
    CreateCompanyComponent,
    DataTableExpoCommodities,
    DataTableHedgeCommodities,
    Dropdown,
    Messages,
    MultiSelect,
    DataModelProgram,
    LeftSidebar,
    NewEditExpoCommodities,
    NewEditHedgeCommodities,
    UploadFile,
  },
  props: {
    colorTheme: { required: true, type: Boolean, default: true },
    commoditySpecs: { required: true, default: () => [] },
    companies: { required: true, default: [{ id: 0, company_name: "N.A." }] },
    processData: { required: true },
    selectedNavAsset: { required: true, default: 1 },
    selectedSheet: { required: true, default: 0 },
    user: { required: true },
  },
  data() {
    return {
      allCommodities: [],
      commodities: [],
      commodityString: null,
      companyInformation: null,
      companyLen: 1,
      createEditTextExpoCommodities: "Add New Commodities Exposure ",
      createEditTextHedgeCommodities: "Add New Hedge",
      datamodel_preferences: {},
      dataSavedExpoCommodities: true,
      dataSavedHedgeCommodities: true,
      dataToExport: [],
      defaultItemExpoCommodities: {},
      defaultItemHedgeCommodities: {},
      editedIndexExpoCommodities: -1,
      editedIndexHedgeCommodities: -1,
      editedItemExpoCommodities: {},
      editedItemHedgeCommodities: {},
      expo_commodities_deleted: [],
      commodities_hedge_deleted: [],
      expoCommodities: [],
      expoOptionsCommodities: [],
      file: "",
      firstCompany: [],
      headersComExpo1: [],
      headersComExpo2: [],
      headersComExpo3: [],
      headersComHedge1: [],
      headersComHedge2: [],
      headersComHedge3: [],
      headersToExport: [],
      hedgeCommodities: [],
      incoterms: [],
      leftRightCurrExpo: "",
      leftRightCurrHedge: "",
      list_file: "",
      logo_blue: require("@/assets/images/QuanspireLogoBlue.svg"),
      logo_white: require("@/assets/images/QuanspireLogoWhite.svg"),
      logo: require("@/assets/images/QuanspireLogoWhite.svg"),
      modal: false,
      modal_edit_company: {
        showModalLoading: false,
        messageModal: "",
        optionsModal: false,
      },
      modal_processing_message: {
        showModalLoading: false,
        messageModal: "",
        optionsModal: false,
      },
      modal_process_finished_message: {
        showModalLoading: false,
        messageModal: "",
        optionsModal: false,
      },
      newSelectedSheet: null,
      optionTypes: [],
      portfolios: [],
      prevSelectedCommodity: [],
      prevSelectedPortfolios: [],
      pricingMethods: [],
      refreshLegendExpoCommodities: "Synced:",
      refreshLegendHedgeCommodities: "Synced:",
      root: document.documentElement,
      saveLegendExpoCommodities: "Saved:",
      saveLegendHedgeCommodities: "Saved",
      selectedCompany: 0,
      selectedCommodity: [],
      selectedPortfolios: [],
      sheetTransaction: null,
      showCompanyPortfolioLoading: false,
      showLoadingComHedge: false,
      showLoadingCompanies: false,
      showLoadingExpoCommodities: false,
      showLoadingStrategies: false,
      showModalEditExpoCommodities: false,
      showModalEditHedgeCommodities: false,
      showModalLoading: false,
      showModalUpload: false,
      showUploadButton: false,
      strategies: [],
      userSelections: {
        selectedAnalysis: "",
        selectedAnalysisParent: "",
        visibleLeft: false,
      },
      watcherCompanySelected: 0,
      watcherForEditCompany: 0,
    };
  },
  created() {
    this.headersComExpo1 = getHeadersComExpo1();
    this.headersComExpo2 = getHeadersComExpo2();
    this.headersComExpo3 = getHeadersComExpo3();
    this.headersComHedge1 = getHeadersComHedge1();
    this.headersComHedge2 = getHeadersComHedge2();
    this.headersComHedge3 = getHeadersComHedge3();
    this.firstCompany = getFirstCompany();
    this.defaultItemExpoCommodities = getDefaultItemExpoCommodities();
    this.editedItemExpoCommodities = getDefaultItemExpoCommodities();
    this.defaultItemHedgeCommodities = getDefaultItemHedgeCommodities();
    this.editedItemHedgeCommodities = getDefaultItemHedgeCommodities();
    this.showLoadingStrategies = true;
    getCommodityStrategiesData(this, "strategies", "showLoadingStrategies");
    getIncoterms(this);
    getPricingMethods(this);
    this.datamodel_preferences = this.$store.state.user_preferences.all.items.datamodel_choices;
    try {
      let selComp = this.$store.state.user_preferences.all.items
        .datamodel_choices.selected_company;
      if (
        !Number.isInteger(selComp) ||
        this.companies.find((d) => d.id === selComp) === undefined
      ) {
        this.selectedCompany = 0;
      } else {
        this.selectedCompany = selComp;
      }
    } catch (error) {
      console.error(`Error selected company ${error}`);
      this.selectedCompany = 0;
    }
    try {
      this.allCommodities = this.$store.state.commodities.all.items;
      this.allCommodities.forEach(function(d) {
        d.fk_idproduct = d.fk_idproduct.toUpperCase();
      });
    } catch (error) {
      console.error(`Error commodities ${error}`);
    }

    setManagementInfoCommodities(
      this,
      0,
      true,
      !this.dataRouteHasSelection(this.$route),
    );
    getExpoOptionsDataCommodities(this);
    getOptionTypesData(this, "headersComHedge1");
    this.changeCompanyInformation();
    this.newSelectedSheet = this.selectedSheet;
    Object.assign(this.userSelections, {
      selectedAnalysis: `eventOnClientSelect${this.selectedSheet}`,
      selectedAnalysisParent: `eventOnClientSelect${this.selectedSheet}`,
    });

    // Apply the company/portfolios/commodities selection carried in the URL
    // (or write the current defaults out so the URL becomes shareable).
    this.applyDataRoute(this.$route);

    document.title = "Data Model | Cmdty";
  },
  watch: {
    companies() {
      this.showModalLoadingF();
      "loading" in this.companies
        ? (this.companyLen = 1)
        : (this.companyLen = this.companies.length);
    },
    selectedCompany() {
      this.changeCompanyInformation();
    },
    optionTypes() {
      if (this.optionTypes.length > 0) {
        this.showLoadingComHedge = true;
        getHedgeDataCommodities(this);
      }
    },
  },
  methods: {
    // ====================== Client Company/Portfolio/Asset Selection ======================
    onClientSelectSheet({ idx }) {
      this.$emit("eventOnClientSelectSheet", idx);
    },
    onUserCompanySelection(event) {
      this.selectedCompany = event.value;
      this.datamodel_preferences.selected_company = this.selectedCompany;
      this.$store.state.user_preferences.all.items.datamodel_choices = this.datamodel_preferences;
      companyPortfolioAsset(this, 0);
      this.setFileNameData();
      saveUserPreferences(this);
      this.changeCompanyInformation();
      this.syncDataRoute();
    },
    onUserPortfolioSelection() {
      if (this.selectedPortfolios !== this.prevSelectedPortfolios) {
        this.prevSelectedPortfolios = this.selectedPortfolios;
        companyPortfolioAsset(this, 1);
      }
      this.syncDataRoute();
    },
    onUserCommoditySelection() {
      if (this.selectedCommodity !== this.prevSelectedCommodity) {
        this.prevSelectedCommodity = this.selectedCommodity;
        companyPortfolioAsset(this, 2);
      }
      this.syncDataRoute();
    },
    onCopyItem(item) {
      this.editedIndexExpoCommodities = this.expoCommodities.indexOf(item);
      item = Object.assign({}, item);
      item.edited = true;
      item.pk = "pending";
      item.pk_idcommodity_exposure = NaN;
      this.expoCommodities.splice(this.editedIndexExpoCommodities, 0, item);
      this.dataSavedExpoCommodities = false;
      this.saveLegendExpoCommodities = "Save:";
      this.refreshLegendExpoCommodities = "Discard:";
    },
    // ====================== CRUD emit from expo table component =======
    onClientSaveToDB(val) {
      if (val === 3) {
        onClientSaveToDBExpoCommodities(this);
      } else if (val === 4) {
        onClientSaveToDBHedgeCommodities(this);
      }
    },
    onBeforeSaveCompany() {
      this.showCompanyPortfolioLoading = true;
    },
    onAfterSaveCompany() {
      this.showCompanyPortfolioLoading = true;
      this.companies = this.$store.state.companies.all.items;
      this.companyLen = this.companies.length;
      const delay_state = this;
      setTimeout(() => (delay_state.showCompanyPortfolioLoading = false), 2000);
      setManagementInfoCommodities(this);
    },
    onBeforeSavePortfolioCompany() {
      this.modal_processing_message.showModalLoading = !this
        .modal_processing_message.showModalLoading;
      this.modal_processing_message.messageModal = "Processing...";
      this.showCompanyPortfolioLoading = true;
    },
    onAfterSavePortfolioCompany(item) {
      this.modal_processing_message.showModalLoading = !this
        .modal_processing_message.showModalLoading;
      this.modal_process_finished_message.showModalLoading = !this
        .modal_process_finished_message.showModalLoading;
      this.modal_process_finished_message.optionsModal = true;
      this.modal_process_finished_message.messageModal = item;

      this.companies = this.$store.state.companies.all.items;
      this.companyLen = this.companies.length;
      setManagementInfoCommodities(this);
      this.showCompanyPortfolioLoading = false;
    },
    editCompanyPortfolios() {
      this.watcherForEditCompany += 1;
      this.modal_edit_company.showModalLoading = !this.modal_edit_company
        .showModalLoading;
      this.modal_edit_company.messageModal = "Edit company and portfolios";
      this.modal_edit_company.optionsModal = true;
    },
    // ====================== CRUD emit from expo table component =======
    onClientCreateExpoCommodities() {
      this.editedItemExpoCommodities = JSON.parse(
        JSON.stringify(this.defaultItemExpoCommodities),
      );
      this.editedItemExpoCommodities.fk_idportfolio = this.selectedPortfolios[0].name;
      this.editedItemExpoCommodities.fk_idcommodity = this.selectedCommodity[0].name;
      this.createEditTextExpoCommodities = "Add New Commodities Exposure ";
      this.showModalEditExpoCommodities = true;
      this.editedIndexExpoCommodities = -1;
    },
    onAfterDeleteHedgeCommodities() {
      this.showLoadingComHedge = true;
      this.hedgeCommodities = [];
      if (this.optionTypes.length > 0) {
        getHedgeDataCommodities(this);
      }
      this.showLoadingCompanies = !this.showLoadingCompanies;
    },
    onAfterDeleteExpoCommodities() {
      this.showLoadingExpoCommodities = true;
      this.expoCommodities = [];
      getExpoDataCommodities(this);
      this.showLoadingCompanies = !this.showLoadingCompanies;
    },
    onAfterDeleteCompany() {
      this.showLoadingExpoCommodities = true;
      this.companyLen = this.companies.length;
      this.showLoadingCompanies = !this.showLoadingCompanies;
    },
    showModalLoadingF() {
      let res = true;
      if (this.companies) {
        res = "loading" in this.companies;
      }
      this.showModalLoading = res;
    },
    editItemExpoCommodities(item) {
      this.editedIndexExpoCommodities = this.expoCommodities.indexOf(item);
      this.editedItemExpoCommodities = JSON.parse(JSON.stringify(item));
      this.createEditTextExpoCommodities = "Edit Exposure";
      this.showModalEditExpoCommodities = true;
    },
    deleteItemExpoCommodities(item) {
      const index = this.expoCommodities.indexOf(item);
      item.fk_idstate = 2;
      this.expo_commodities_deleted.push(item);
      this.expoCommodities.splice(index, 1);
      this.dataSavedExpoCommodities = false;
      this.saveLegendExpoCommodities = "Save:";
      this.refreshLegendExpoCommodities = "Discard:";
    },
    onClientDiscardExpoCommodities() {
      this.expoCommodities = [];
      this.showLoadingExpoCommodities = true;
      if (this.optionTypes.length > 0) {
        getExpoDataCommodities(this);
      }
    },
    onUserCancel() {
      this.showModalEditExpoCommodities = false;
      this.showModalEditHedgeCommodities = false;
    },
    validateBeforeSubmitCommodities(val) {
      val.fk_idcommodity = val.fk_idcommodity.toUpperCase();
      this.editedItemExpoCommodities = val;
      this.saveExpoCommodities();
      this.showModalEditExpoCommodities = false;
    },
    saveExpoCommodities() {
      let item;
      if (this.editedIndexExpoCommodities > -1) {
        item = this.fixExpoJson(
          JSON.parse(JSON.stringify(this.editedItemExpoCommodities)),
        );
        Object.assign(
          this.expoCommodities[this.editedIndexExpoCommodities],
          item,
        );
      } else {
        this.editedItemExpoCommodities.pk = "pending";
        item = this.fixExpoJson(
          JSON.parse(JSON.stringify(this.editedItemExpoCommodities)),
        );
        this.expoCommodities.splice(0, 0, item);
      }
      this.defaultItemExpoCommodities = this.fixExpoJson(
        JSON.parse(JSON.stringify(this.editedItemExpoCommodities)),
      );
      let _this = this;
      this.commodityString = this.commodities[this.selectedCommodity[0].id];
      this.allCommodities.forEach(function(d) {
        if (
          d.fk_idproduct.toUpperCase() ===
          _this.commodityString.name.toUpperCase()
        ) {
          _this.defaultItemExpoCommodities.commodity_unit = d.fk_idunit;
          _this.defaultItemExpoCommodities.quotation =
            d.fk_idcurrency + "/" + d.fk_idunit;
        }
      });
      this.dataSavedExpoCommodities = false;
      this.saveLegendExpoCommodities = "Save:";
      this.refreshLegendExpoCommodities = "Discard:";
    },
    fixExpoJson(item) {
      if (item.rate_at_issue_date === "") {
        item.rate_at_issue_date = null;
      }
      if (item.rate_at_realized_expiration_date === "") {
        item.rate_at_realized_expiration_date = null;
      }
      if (item.settlement_pnl === "") {
        item.settlement_pnl = null;
      }
      item.date = timeParseNoNull(item.date);
      item.sale_date = timeParseNoNull(item.sale_date);
      item.shipping_date = timeParseNoNull(item.shipping_date);
      if (item.contract_month_year !== "") {
        item.contract_month_year = contractMonthYearParse(
          item.contract_month_year,
        );
      }
      if (item.continuation_month <= 0 || item.continuation_month === "") {
        item.continuation_month = null;
      }
      return item;
    },
    onCopyItemHedge(item) {
      this.editedIndexHedgeCommodities = this.hedgeCommodities.indexOf(item);
      item = Object.assign({}, item);
      item.edited = true;
      item.pk = "pending";
      item.pk_idcommodityhedge = NaN;
      this.hedgeCommodities.splice(this.editedIndexHedgeCommodities, 0, item);
      this.dataSavedHedgeCommodities = false;
      this.saveLegendHedgeCommodities = "Save:";
      this.refreshLegendHedgeCommodities = "Discard:";
    },
    // ====================== CRUD emit from hedge table component =======
    onClientCreateHedgeCommodities() {
      this.editedItemHedgeCommodities = JSON.parse(
        JSON.stringify(this.defaultItemHedgeCommodities),
      );
      this.editedItemHedgeCommodities.fk_idportfolio = this.selectedPortfolios[0].name;
      this.editedItemHedgeCommodities.fk_idcommodity = this.selectedCommodity[0].name;
      this.createEditTextHedgeCommodities = "Add New Hedge";
      this.showModalEditHedgeCommodities = true;
      this.editedIndexHedgeCommodities = -1;
    },
    editItemHedgeCommodities(item) {
      this.editedIndexHedgeCommodities = this.hedgeCommodities.indexOf(item);
      if (item.contract_month_year === null) {
        item.contract_month_year = "";
      }
      if (item.continuation_month === null) {
        item.continuation_monthsel = "";
      }
      this.editedItemHedgeCommodities = JSON.parse(JSON.stringify(item));
      this.createEditTextHedgeCommodities = "Edit Hedge";
      this.showModalEditHedgeCommodities = true;
    },
    deleteItemHedgeCommodities(item) {
      const index = this.hedgeCommodities.indexOf(item);
      item.fk_idstate = 2;
      this.commodities_hedge_deleted.push(item);
      this.hedgeCommodities.splice(index, 1);
      this.dataSavedHedgeCommodities = false;
      this.saveLegendHedgeCommodities = "Save:";
      this.refreshLegendHedgeCommodities = "Discard:";
    },
    onClientDiscardHedgeCommodities() {
      this.hedgeCommodities = [];
      this.showLoadingComHedge = true;
      if (this.optionTypes.length > 0) {
        getHedgeDataCommodities(this);
      }
    },
    validateBeforeSubmitHedgeCommodities(val) {
      this.editedItemHedgeCommodities = val;
      this.saveHedgeCommodities();
      this.showModalEditHedgeCommodities = false;
    },
    saveHedgeCommodities() {
      if (this.editedIndexHedgeCommodities > -1) {
        Object.assign(
          this.hedgeCommodities[this.editedIndexHedgeCommodities],
          this.fixHedgeJson(
            JSON.parse(JSON.stringify(this.editedItemHedgeCommodities)),
          ),
        );
      } else {
        this.hedgeCommodities.splice(
          0,
          0,
          this.fixHedgeJson(
            JSON.parse(JSON.stringify(this.editedItemHedgeCommodities)),
          ),
        );
        this.defaultItemHedgeCommodities = this.fixHedgeJson(
          JSON.parse(JSON.stringify(this.editedItemHedgeCommodities)),
        );
      }
      this.dataSavedHedgeCommodities = false;
      this.saveLegendHedgeCommodities = "Save:";
      this.refreshLegendHedgeCommodities = "Discard:";
    },
    fixHedgeJson(item) {
      if (item.barrier === "") {
        item.barrier = null;
      }
      if (item.barrier_2 === "") {
        item.barrier_2 = null;
      }
      if (item.spot_reference === "") {
        item.spot_reference = null;
      }
      if (item.settlement_rate === "") {
        item.settlement_rate = null;
      }
      if (item.settlement_pnl === "") {
        item.settlement_pnl = null;
      }
      item.trade_date = timeParseNoNull(item.trade_date);
      item.fixing_date = timeParseNoNull(item.fixing_date);
      item.value_date = timeParseNoNull(item.value_date);
      item.premium_value_date = timeParseNoNull(item.premium_value_date);
      item.asian_fixing_start_date = timeParseNoNull(
        item.asian_fixing_start_date,
      );
      item.hedged_date = timeParseNoNull(item.hedged_date);
      item.sale_date = timeParseNoNull(item.sale_date);
      item.shipping_date = timeParseNoNull(item.shipping_date);
      if (item.contract_month_year !== "") {
        item.contract_month_year = contractMonthYearParse(
          item.contract_month_year,
        );
      }
      if (item.continuation_month <= 0 || item.continuation_month === "") {
        item.continuation_month = null;
      }
      return item;
    },
    // ====================== Variables calculation ======================
    setFileNameData() {
      this.list_file = [this.companies[this.selectedCompany].company_name];
    },
    //  ====================== User interactions  ======================
    changeVisible() {
      Object.assign(this.userSelections, {
        visibleLeft: !this.userSelections.visibleLeft,
      });
    },
    onLeftSidebarAnalysis({ val, parent }) {
      Object.assign(this["userSelections"], {
        selectedAnalysisParent: parent,
      });
      Object.assign(this["userSelections"], {
        selectedAnalysis: val,
      });
      setTimeout(() => {
        Object.assign(this["userSelections"], {
          visibleLeft: false,
        });
      }, 500);
    },
    onUserClickLeftSidebarShow(val) {
      Object.assign(this["userSelections"], {
        visibleLeft: val,
      });
    },
    changeCompanyInformation() {
      const companySel = this.companies[this.selectedCompany];
      Object.assign(this, {
        companyInformation: {
          idCompany: companySel.pk_idcompany,
          companyName: companySel.company_name,
        },
      });
    },
    //  ====================== Set styles  ======================
    getStyleConteiner() {
      if (this.selectedSheet === 3) {
        return "container-curr-actions-l";
      } else {
        return "container-curr-actions-xl";
      }
    },
  },
};
</script>

<style scoped>
.parent-uploadFile {
  width: 95%;
  height: 90%;
}
.container-curr-actions-l {
  width: 95%;
}
.container-curr-actions-xl {
  width: 100%;
}
</style>
